import { useState } from 'react';
import { RulesTab } from './RulesTab';
import { ChainsTab } from './ChainsTab';
import { GroupsTab } from './GroupsTab';
import { SdtTab } from './SdtTab';
import { ChangesTab } from './ChangesTab';

/** Alerting configuration hub: rules → chains → recipient groups →
 *  scheduled downtime → change windows, in the order operators reason about them. */
const TABS = [
  { key: 'rules', label: 'Alert rules' },
  { key: 'chains', label: 'Escalation chains' },
  { key: 'groups', label: 'Recipient groups' },
  { key: 'sdt', label: 'Scheduled downtime' },
  { key: 'changes', label: 'Change windows' },
] as const;

type TabKey = (typeof TABS)[number]['key'];

export function AlertingPage() {
  const [tab, setTab] = useState<TabKey>('rules');
  return (
    <div className="page">
      <h1 className="page-title">Alerting</h1>
      <div className="tab-bar" role="tablist" aria-label="Alerting configuration">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={tab === t.key}
            className={tab === t.key ? 'tab tab-active' : 'tab'}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'rules' && <RulesTab />}
      {tab === 'chains' && <ChainsTab />}
      {tab === 'groups' && <GroupsTab />}
      {tab === 'sdt' && <SdtTab />}
      {tab === 'changes' && <ChangesTab />}
    </div>
  );
}
